import { DataInfoCardVariant } from "@/components/DataInfoCard";
import TextsReadByGradeLevel from "../../classroom-data/ClassroomMainPage/components/TextsReadByGradeLevel";
import StudentReadingGradeLevel from "../../student-data/StudentInsightsMainPage/components/StudentReadingGradeLevel";
import { ValidReadingLevelStatus } from "../../student-data/StudentInsightsMainPage/components/StudentReadingGradeLevel/StudentReadingGradeLevel";
import AverageReadingLevelCard from "./components/AverageReadingLevelCard";
import ReadingGradeLevelCard from "./components/ReadingGradeLevelCard";
import ReadingMetricsCard from "./components/ReadingMetricsCard";
import {
  overviewDataResultsCss,
  overviewDataResultsWithNweaCss,
} from "./OverviewDataResults.style";
import { OverviewDataResultsProps } from "./OverviewDataResults.type";

const getAverageMinutesPerArticleValue = (timeInSeconds: number) => {
  if (timeInSeconds >= 60) {
    return Math.round(timeInSeconds / 60);
  }
  if (timeInSeconds > 0) return 1;
  return 0;
};

const OverviewDataResults = ({
  data,
  isClassroomPage,
  loading,
  error,
  studentFirstName,
  nweaScore,
  nweaScoreLoading,
}: OverviewDataResultsProps) => {
  const readingMetricsTotalTextsContent = isClassroomPage
    ? "Total texts viewed by class"
    : `Total texts viewed by ${studentFirstName}`;
  const readingMetricsAverageMinutesContent = isClassroomPage
    ? "Minutes average reading time"
    : "Average minutes per article";

  const averageGradeLevel = data?.article_grade_level_viewed_average || "N/A";
  const averageLexileLevelData = data?.article_lexile_level_viewed_average;
  const averageLexileLevel =
    averageLexileLevelData !== "0L" && averageLexileLevelData !== undefined
      ? averageLexileLevelData
      : "N/A";
  const articlesViewedCount = data?.articles_viewed_count || 0;
  const articleTimeAverageSecs = data?.article_time_average || 0;
  const averageMinutesPerArticle = getAverageMinutesPerArticleValue(
    articleTimeAverageSecs,
  );
  const displayLessThanSign =
    articleTimeAverageSecs > 0 && articleTimeAverageSecs < 60;

  const aboveGradeLevelCount =
    data && "articles_above_grade_level_count" in data
      ? data.articles_above_grade_level_count
      : 0;
  const atGradeLevelCount =
    data && "articles_at_grade_level_count" in data
      ? data.articles_at_grade_level_count
      : 0;
  const belowGradeLevelCount =
    data && "articles_below_grade_level_count" in data
      ? data.articles_below_grade_level_count
      : 0;

  const readingLevelStatus =
    data &&
    "student_quiz_level_equivalence_median" in data &&
    (data.student_quiz_level_equivalence_median as ValidReadingLevelStatus);

  const studentGradeLevelStatus = readingLevelStatus
    ? ValidReadingLevelStatus[readingLevelStatus]
    : ValidReadingLevelStatus.noActivity;

  const weeklyTrendLevel =
    data && "articles_weekly_trend_level" in data
      ? data.articles_weekly_trend_level
      : 0;
  return (
    <>
      <div
        css={
          nweaScore ? overviewDataResultsWithNweaCss : overviewDataResultsCss
        }
      >
        <AverageReadingLevelCard
          averageGradeLevel={averageGradeLevel}
          averageLexileLevel={averageLexileLevel}
          isClassroomPage={isClassroomPage}
          studentFirstName={studentFirstName ?? ""}
          loading={loading}
          error={error}
        />
        {nweaScore ? (
          <ReadingMetricsCard
            total={nweaScore}
            textContentValue="NWEA MAP Growth"
            isClassroomPage={isClassroomPage}
            cardVariant={DataInfoCardVariant.circle}
            isNweaCard
            loading={nweaScoreLoading}
            error={false}
          />
        ) : null}
        <ReadingMetricsCard
          total={articlesViewedCount}
          textContentValue={readingMetricsTotalTextsContent}
          isClassroomPage={isClassroomPage}
          cardVariant={DataInfoCardVariant.circle}
          loading={loading}
          error={error}
        />
        <ReadingMetricsCard
          total={averageMinutesPerArticle}
          textContentValue={readingMetricsAverageMinutesContent}
          displayLessThanSign={displayLessThanSign}
          isClassroomPage={isClassroomPage}
          cardVariant={DataInfoCardVariant.progressCircle}
          loading={loading}
          error={error}
        />
        {isClassroomPage ? (
          <ReadingGradeLevelCard error={error}>
            <TextsReadByGradeLevel
              weeklyTrendLevel={weeklyTrendLevel}
              aboveGradeLevel={aboveGradeLevelCount}
              atGradeLevel={atGradeLevelCount}
              belowGradeLevel={belowGradeLevelCount}
              isLoading={loading}
            />
          </ReadingGradeLevelCard>
        ) : (
          <ReadingGradeLevelCard error={error} loading={loading}>
            <StudentReadingGradeLevel
              studentReadingLevelStatus={studentGradeLevelStatus}
              studentFirstName={studentFirstName ?? ""}
              articlesViewedCount={articlesViewedCount}
            />
          </ReadingGradeLevelCard>
        )}
      </div>
    </>
  );
};

export default OverviewDataResults;
